import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoggerService } from '../logger/logger.service';

@Injectable({
    providedIn: "root"
})
export class HttpLoggerInterceptor  implements HttpInterceptor {
	private readonly loggerName: string = "HttpLoggerInterceptor";

	constructor(private logger: LoggerService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const startTime = Date.now();
		
		// Log request details
		const requestDetails = {
			method: req.method,
			url: req.url,
			headers: req.headers.keys().reduce((acc, key) => {
				acc[key] = req.headers.get(key);
				return acc;
			}, {} as Record<string, string>)
		};
		
		this.logger.debug(this.loggerName, `HTTP Request: ${req.method} ${req.url}`, requestDetails);

		return next.handle(req).pipe(
			tap({
				next: (event: HttpEvent<any>) => {
					if (event instanceof HttpResponse) {
						const duration = Date.now() - startTime;
						const responseDetails = {
							method: req.method,
							url: req.url,
							status: event.status,
							statusText: event.statusText,
							duration: `${duration}ms`,
							headers: event.headers.keys().reduce((acc, key) => {
								acc[key] = event.headers.get(key);
								return acc;
							}, {} as Record<string, string>)
						};
						
						if (event.status >= 400) {
							this.logger.error(this.loggerName, `HTTP Response Error: ${req.method} ${req.url}`, responseDetails);
						} else {
							this.logger.debug(this.loggerName, `HTTP Response Success: ${req.method} ${req.url}`, responseDetails);
						}
					}
				},
				error: (error: any) => {
					const duration = Date.now() - startTime;
					const errorDetails = {
						method: req.method,
						url: req.url,
						duration: `${duration}ms`,
						error: error instanceof HttpErrorResponse ? {
							status: error.status,
							statusText: error.statusText,
							message: error.message
						} : {
							message: error.message || String(error)
						}
					};
					
					this.logger.error(this.loggerName, `HTTP Request Failed: ${req.method} ${req.url}`, errorDetails);
				}
			})
		);
	}
}